(function () {
	'use strict';

	angular
		.module('app')
		.controller('SystemMessageListController', systemMessageListController);

	function systemMessageListController($scope, $http, $cookies, $location, $rootScope, $timeout, $interval, $state, SystemMessageService, toaster) {

		var model = this;
		model.SystemMessages = [];
		model.SystemMessageRead = false;
		model.SystemMessageEdit = false;
		model.SystemMessageCreate = true;
		model.filterText = '';
		model.Predicate = '';
		model.Reverse = false;
        model.loading = false;

        $scope.systemMessageEdit = function (id) {
            $state.go('systemMessageEdit', { id: id })
        };

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');

        }

		//angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
		//	if (userPermissionRow[0] === 18) {
		//		if (userPermissionRow[1] === 1) {
		//			model.SystemMessageRead = true;
		//		} else if (userPermissionRow[1] === 2) {
		//			model.SystemMessageEdit = true;
		//		} else if (userPermissionRow[1] === 3) {
		//			model.SystemMessageCreate = true;
		//		}
		//	}
		//});

		//if (!model.SystemMessageRead) {
		//	$state.go('permissionDenied');
		//}

		//model.Sort = function (predicate) {
		//	model.Reverse = model.Predicate === predicate ? !model.Reverse : false;
		//	model.Predicate = predicate;
		//}

		//function get() {
		//	model.loading = true;
		//	SystemMessageService.getMessages().then(function (response) {
		//		if (response) {
		//			model.SystemMessages = response;
		//		}
		//		else {
		//			toaster.pop({
		//				type: 'error',
		//				title: 'Error!',
		//				body: 'No System Messages Found',
		//				timeout: 5000
		//			});
		//		}
		//		model.loading = false;
		//	},
		//  function () {
		//  	model.SystemMessages = null;
		//  	model.loading = false;
		//  	toaster.pop({
		//  		type: 'error',
		//  		title: 'Error!',
		//  		body: 'There was some error while getting System Messages. Please contact system administrator',
		//  		timeout: 5000
		//  	});
		//  });
		//};

		//get();

		//model.deleteMessage = function (id) {
		//    SystemMessageService.deleteMessage(id).then(function (response) {
		//        if (response) {
		//            get();
		//            toaster.pop({
		//                type: 'success',
		//                title: 'Success!',
		//                body: 'Message successfully deleted.',
		//                timeout: 5000
		//            });
		//        } else {
		//            toaster.pop({
		//                type: 'error',
		//                title: 'Error!',
		//                body: 'Message not found.',
		//                timeout: 5000
		//            });
		//        }
		//    },
		//	function () {
		//	    toaster.pop({
		//	        type: 'error',
		//	        title: 'Error!',
		//	        body: 'There was an error deleting system message. Please contact system administrator.',
		//	        timeout: 5000
		//	    });
		//	});
		//}
	}
})();

